<script setup lang="ts">
import {
  useRouterStore,
  useStatsigEventsStore,
} from '@apps/main/new-desktop/core/stores';

import { AppSvgIcon, AppRouterLink } from '@libs/ui';

const routerStore = useRouterStore();
const statsigEventsStore = useStatsigEventsStore();

interface AccommodationCardSelectedFooterProps {
  ingredientIndex: number;
}
const props = defineProps<AccommodationCardSelectedFooterProps>();

function onNavigationTriggered(): void {
  statsigEventsStore.logTripOverviewExploreMoreHotelCardClicked();
}
</script>

<template>
  <AppRouterLink
    :link="routerStore.getHotelSelectionUrl(props.ingredientIndex)"
    font="font-link-s"
    color="color-black"
    wide
    @navigation-triggered="onNavigationTriggered"
  >
    <div class="accommodation-card-selected-footer">
      <div class="information">
        <span>{{ $t('overview_accommodation_footer.not_right') }}</span>
        <div>
          <div class="link-wrapper">
            <AppSvgIcon name="lookingGlass" size="18" />
            <span class="link-text">
              {{ $t('overview_accommodation_footer.explore') }}
            </span>
          </div>
        </div>
      </div>
      <div class="label">{{ $t('planner.included') }}</div>
    </div>
  </AppRouterLink>
</template>

<style scoped lang="scss">
.accommodation-card-selected-footer {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: var(--color-secondary-97);
  border-radius: var(--border-radius-8);
  margin: 0 var(--spacing-16) var(--spacing-16) var(--spacing-16);
  padding: var(--spacing-8);
  gap: var(--spacing-4);
  .information {
    @include font-link-s-bold;
    color: var(--color-black);
    display: flex;
    flex-direction: column;
    gap: var(--spacing-4);

    .link-wrapper {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: var(--spacing-4);
      .link-text {
        text-decoration: underline;
      }
    }
  }
  .label {
    @include font-label-s-light;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--color-white);
    padding: calc(var(--spacing-8) + var(--spacing-2)) var(--spacing-12);
    border-radius: var(--spacing-8);
    background-color: var(--color-brand-violet);
    height: fit-content;
  }
}
</style>
